<template>
  <div class="row">
    <h2 v-if="title" class="cell small-10 h1">
      {{ title }}
    </h2>

    <div class="skeleton-cell">
      <AtomicUiSkeleton width="95%" height="10rem" />
    </div>
    <div class="skeleton-cell hide-for-small-only">
      <AtomicUiSkeleton width="95%" height="10rem" />
    </div>
    <div class="skeleton-cell hide-for-small-only">
      <AtomicUiSkeleton width="95%" height="10rem" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.skeleton-cell {
  width: 33%;
  float: left;
  padding: rem-calc(2);
}
@media only screen and (max-width: 600px) {
  .skeleton-cell {
    width: 100%;
  }
}
</style>
